import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class CmdkService {
    //#region State
    private readonly searchSub = new Subject<string>();
    public readonly search$ = this.searchSub.asObservable();
    private readonly itemClickedSub = new Subject<string>();
    public readonly itemClicked$ = this.itemClickedSub.asObservable();
    private readonly itemValueChangedSub = new Subject<{
        oldValue: string;
        newValue: string;
    }>();
    public readonly itemValueChanged$ = this.itemValueChangedSub.asObservable();
    //#endregion

    //#region Public methods
    public setSearch(value: string): void {
        this.searchSub.next(value);
    }

    public itemClicked(value: string): void {
        this.itemClickedSub.next(value);
    }

    public itemValueChanged(oldValue: string, newValue: string): void {
        this.itemValueChangedSub.next({ oldValue, newValue });
    }
    //#endregion
}
